<template>
  <div class="shop-navbar">
    <app-btn
      class="btn btn-nav-dark btn-sm w-100"
      @click="$emit('openSorting')"
    >
      <div class="d-flex align-items-center justify-content-center">
        <i class="ic ic-sm ic-icon-sort" />
        <span>{{ sortOptionLabel }}</span>
      </div>
    </app-btn>
    <app-btn
      class="btn btn-nav-dark btn-sm w-100"
      @click="$emit('openFilters')"
    >
      <div class="d-flex align-items-center justify-content-center">
        <i v-if="isFiltersDirty" class="ic ic-sm ic-icon-filter-applied" />
        <i v-else class="ic ic-sm ic-icon-filter" />
        <span>Фільтр</span>
      </div>
    </app-btn>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import AppBtn from "@/components/common/ui/AppBtn.vue";

export default {
  name: "ShopNavbar",
  components: {
    AppBtn,
  },
  setup() {
    const store = useStore();

    const sortOption = computed(() => store.state.shop.sortOption);

    const sortOptionLabel = computed(() => {
      switch (sortOption.value) {
        case "price_desc":
          return "За зменшенням ціни";
        case "price_asc":
        default:
          return "За зростанням ціни";
      }
    });

    const isFiltersDirty = computed(() => store.getters["shop/isFiltersDirty"]);

    return {
      sortOptionLabel,
      isFiltersDirty,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";

.shop-navbar {
  position: relative;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(1, 1fr);
  margin-bottom: 20px;
  z-index: 2;

  @media (min-width: 320px) {
    margin-bottom: 20px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media @md {
    gap: 25px;
    margin-bottom: 25px;
  }

  @media @lg {
    gap: 30px;
    margin-bottom: 30px;
  }

  .ic-icon-sort,
  .ic-icon-filter {
    margin-right: 6px;
  }
}
</style>
